/* eslint-disable react/no-children-prop */
import React from 'react';
import { Stepper, Step, StepLabel } from '@material-ui/core';

import { useStyles } from './VideoStepper.styles';
import { VideoStepperProps } from './VideoStepper.types';

export const VideoStepper = ({ activeStep, steps }: VideoStepperProps) => {
  const styles = useStyles();

  return (
    <Stepper activeStep={activeStep} className={styles.stepperContainer} alternativeLabel>
      {steps.map(i => (
        <Step key={i.label}>
          <StepLabel
            classes={{
              iconContainer: styles.activeIcon,
              label: styles.labelText,
            }}
            children=""
          />
          <div className={styles.labelText}>{i.label}</div>
        </Step>
      ))}
    </Stepper>
  );
};
